import { Box } from '@mui/material'
import ApplicationBar from 'components/AppBar/ApplicationBar'
import { ReactNode } from 'react'
import GlobalConfirmDialog from 'components/Dialog/GlobalConfirmDialog'
import { useScreenSize } from 'hooks/useScreenSize/useScreenSize'
import NavSideBar from 'components/SideNavigation/SideNavigation'
import { useAppSelector } from 'store/useStoreHook'

interface OrderDashboardLayoutProps {
    children: ReactNode
}
const menuWidth = 284

function OrderDashboardLayout(props: OrderDashboardLayoutProps) {
    const { children } = props
    const { open } = useAppSelector((state) => state.drawer)
    const { isMobileTablet, isMediumScreen } = useScreenSize()
    return (
        <div
            style={{
                width: '100%',
            }}
        >
            <ApplicationBar
                menuToggleBtn={true}
                position={isMediumScreen ? 'static' : 'fixed'}
                hideHWagent={false}
                hideUser={false}
                titleText="Order Dashboard"
            />
            <NavSideBar />
            <main style={{ display: 'flex' }}>
                {!isMobileTablet && open && (
                    <Box>
                        <div
                            style={{ minWidth: menuWidth, height: '50px' }}
                        ></div>
                    </Box>
                )}
                <Box
                    sx={{
                        width:
                            !isMobileTablet && open
                                ? 'calc(100vw - 284px)'
                                : '100vw',
                    }}
                >
                    {children}
                </Box>
            </main>
            <GlobalConfirmDialog />
        </div>
    )
}
export default OrderDashboardLayout
